export default __webpack_public_path__ + "static/media/matchmaker-landing.223c7a98.webp";